module.exports = __webpack_public_path__ + "media/images/city_img/j_1-ce9e4c49e26a2a766b63556402c46559.jpg";